/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Mobile Megamenu Handler
  function initMobileMegamenu() {
    if (window.innerWidth > 1024) return;
    
    const nav = document.querySelector('.nav--default');
    const menuItems = document.querySelectorAll('.nav--default .menu__item');
    
    // Handle close button click
    if (nav) {
      nav.addEventListener('click', function(e) {
        if (e.target === nav && e.offsetX > nav.offsetWidth - 60 && e.offsetY < 60) {
          document.body.classList.remove('js-drawer-open-header');
        }
      });
    }
    
    // Handle overlay click (the theme renders a real .drawer__overlay element)
    document.addEventListener('click', function(e) {
      if (e.target.closest('.drawer__overlay')) {
        document.body.classList.remove('js-drawer-open-header');
      }
    });
    
    // Make megamenu items expandable on mobile
    menuItems.forEach(item => {
      const topLink = item.querySelector('[data-top-link]');
      const hasDropdown = item.querySelector('.header__dropdown');
      
      if (hasDropdown && topLink) {
        topLink.addEventListener('click', function(e) {
          if (window.innerWidth <= 1024) {
            e.preventDefault();
            item.classList.toggle('is-visible');
          }
        });
      }
    });
  }
  
  // Initialize on load
  document.addEventListener('DOMContentLoaded', initMobileMegamenu);
  
  // Reinitialize on resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initMobileMegamenu, 250);
  });

  // No Variant Selected by Default - Hide Add to Cart and Buy It Now buttons
  function initVariantSelection() {
    const productForms = document.querySelectorAll('[data-product-form]');
    
    productForms.forEach(function(form) {
      const product = form.closest('[data-product]');
      if (!product) return;
      
      const addToCartButton = product.querySelector('[data-add-to-cart]');
      const buyItNowContainer = product.querySelector('.shopify-payment-button');
      const variantSelectors = product.querySelectorAll('[data-single-option-selector]');
      const idInput = form.querySelector('[name="id"]');
      
      // Function to check if a valid variant is selected
      function hasValidVariantSelected() {
        // Check if there's a variant ID in the hidden input
        const variantId = idInput ? idInput.value : '';
        if (!variantId || variantId === '') {
          return false;
        }
        
        // Check if all option selectors have values (not placeholder)
        let allOptionsSelected = true;
        variantSelectors.forEach(function(selector) {
          const value = selector.value || '';
          if (value === '' || selector.closest('[data-placeholder-option]')) {
            allOptionsSelected = false;
          }
        });
        
        return allOptionsSelected;
      }
      
      // Function to update button visibility
      function updateButtonVisibility() {
        const isValidVariant = hasValidVariantSelected();
        
        if (addToCartButton) {
          if (isValidVariant) {
            product.classList.remove('variant-not-selected');
            addToCartButton.classList.remove('hidden');
          } else {
            product.classList.add('variant-not-selected');
            addToCartButton.classList.add('hidden');
          }
        }
        
        if (buyItNowContainer) {
          if (isValidVariant) {
            buyItNowContainer.classList.remove('hidden');
          } else {
            buyItNowContainer.classList.add('hidden');
          }
        }
      }
      
      // Initialize - check initial state
      updateButtonVisibility();
      
      // Listen for changes on variant selectors (radio, checkbox, select)
      variantSelectors.forEach(function(selector) {
        selector.addEventListener('change', function() {
          // Small delay to let the form update
          setTimeout(updateButtonVisibility, 50);
        });
      });
      
      // Listen for changes on dropdown selectors (popout-select)
      const popoutSelects = product.querySelectorAll('[data-popout-option]');
      popoutSelects.forEach(function(option) {
        option.addEventListener('click', function(e) {
          e.preventDefault();
          const value = option.getAttribute('data-value');
          
          // Check if it's a placeholder option
          if (value === '' || option.hasAttribute('data-placeholder-option')) {
            setTimeout(function() {
              product.classList.add('variant-not-selected');
              if (addToCartButton) addToCartButton.classList.add('hidden');
              if (buyItNowContainer) buyItNowContainer.classList.add('hidden');
            }, 100);
          } else {
            // Wait for the form to update the variant
            setTimeout(updateButtonVisibility, 100);
          }
        });
      });
      
      // Observer for dynamic changes to the ID input (in case theme.js updates it)
      if (idInput) {
        const observer = new MutationObserver(function() {
          updateButtonVisibility();
        });
        observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });
      }
    });
  }
  
  // Initialize on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', initVariantSelection);
  
  // Also initialize on Shopify section load (for quick view, etc.)
  document.addEventListener('shopify:section:load', initVariantSelection);


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
